<template>
  <div class="details person">

    <template v-for="(pval, pkey) in persons">
      <table :key="pkey">
        <tbody>
          <tr v-if="pval.title">
            <td>{{ _.title }}</td>
            <td>{{ pval.title }}</td>
          </tr>
          <tr>
            <td>{{ _.first_name }}</td>
            <td>{{ pval.first_name }}</td>
          </tr>
          <tr>
            <td>{{ _.last_name }}</td>
            <td>{{ pval.last_name }}</td>
          </tr>
          <tr v-if="pval.institution">
            <td>{{ _.institution }}</td>
            <td>{{ pval.institution }}</td>
          </tr>
          <tr v-if="pval.department">
            <td>{{ _.department }}</td>
            <td>{{ pval.department }}</td>
          </tr>
          <tr v-if="pval.function">
            <td>{{ _.function }}</td>
            <td>{{ pval.function }}</td>
          </tr>
          <tr v-if="pval.street">
            <td>{{ _.street }}</td>
            <td>{{ pval.street }}</td>
          </tr>
          <tr v-if="pval.zip_code">
            <td>{{ _.zip_code }}</td>
            <td>{{ pval.zip_code }}</td>
          </tr>
          <tr v-if="pval.city">
            <td>{{ _.city }}</td>
            <td>{{ pval.city }}</td>
          </tr>
          <tr v-if="pval.country">
            <td>{{ _.country }}</td>
            <td>{{ pval.country.value.kfz }}</td>
          </tr>
        </tbody>
      </table>
    </template>

  </div>
</template>

<script>
import { API_URL } from '@/config'
import { mapGetters } from 'vuex'
export default {
  props: ['id'],
  data() {
    return {
      persons: {},
    }
  },
  computed: {
    ...mapGetters(['details']),
  },
  async created() {
    const persons = await this.axios.get(API_URL + '/persons/' + this.id + '/details');
    this.persons = persons.data;
    this.setProgress(false);
  }
}
</script>

<style lang="scss">
.details.person {
  // padding: 12px;
  > table {
    > tbody {
      > tr {
        td:first-child {
          width: 120px;
        }
        td:not(:first-child) {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
